import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4814785b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md-checkbox" }
const _hoisted_2 = ["for"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "check", -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps({
      type: "checkbox",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleOnClick && _ctx.toggleOnClick(...args)))
    }, { id: _ctx.id, disabled: _ctx.disabled, name: _ctx.name, required: _ctx.required, value: _ctx.value, checked: _ctx.checked }), null, 16),
    _createElementVNode("label", {
      for: _ctx.id,
      class: _normalizeClass([_ctx.align, _ctx.disabled ? 'disabled' : ''])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["box", { active: _ctx.isChecked, disabled: _ctx.disabled }])
      }, _hoisted_4, 2),
      (_ctx.hasDefaultSlot)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ]))
}